import { education } from "./educationData";

export default function Education() {
  return (
    <section
      id="education"
      className="relative bg-[#0b0b0b] py-28 overflow-hidden text-white"
    >
      {/* Animated Background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(255,180,80,0.12),transparent_60%)] animate-pulse" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_right,rgba(0,200,200,0.08),transparent_70%)]" />

      {/* Floating elements */}
      <div className="absolute top-1/3 right-1/4 w-80 h-80 bg-cyan-400/10 rounded-full blur-3xl animate-float opacity-20" />

      <h2 className="relative z-10 text-center text-6xl font-bold mb-24 tracking-wide">
        <span className="text-gray-300">Edu</span>
        <span className="text-transparent bg-linear-to-r from-orange-400 to-cyan-400 bg-clip-text">
          cation
        </span>
      </h2>

      <div className="relative z-10 max-w-5xl mx-auto px-6">
        {/* Enhanced Center Timeline Line */}
        <div className="absolute left-1/2 -translate-x-1/2 top-0 h-full w-1 bg-linear-to-b from-orange-400 via-cyan-400 to-transparent rounded-full hidden md:block" />

        {/* Glow effect on timeline */}
        <div className="absolute left-1/2 top-0 h-full w-16 bg-cyan-400/20 blur-2xl hidden md:block" />

        {education.map((item, index) => (
          <div
            key={index}
            className={`mb-24 flex w-full ${
              item.side === "left"
                ? "justify-start"
                : "justify-start md:justify-end"
            }`}
          >
            <div
              className={`w-full md:w-[45%] ${
                item.side === "left"
                  ? "text-left md:text-right md:pr-10"
                  : "text-left md:pl-10"
              }`}
            >
              {/* Timeline Dot */}
              <div className="absolute left-0 top-8 -translate-y-1/2 w-3 h-3 bg-linear-to-r from-orange-400 to-cyan-400 rounded-full shadow-[0_0_20px_rgba(0,200,200,0.8)] md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/4 md:w-4 md:h-4" />

              {/* Card */}
              <div
                className="block w-full md:inline-block rounded-2xl glass-morphism border-white/20 p-6
                transition-all duration-500 hover:shadow-[0_0_30px_rgba(0,200,200,0.6)] hover:border-cyan-400/50
                hover:scale-105 hover:bg-white/20 cursor-default group animate-fade"
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                {/* Year Badge */}
                <span className="inline-block mb-3 text-sm font-bold text-transparent bg-linear-to-r from-orange-400 to-cyan-400 bg-clip-text">
                  {item.year}
                </span>
                <h3 className="text-lg font-bold text-white group-hover:text-transparent group-hover:bg-linear-to-r group-hover:from-orange-400 group-hover:to-cyan-400 group-hover:bg-clip-text transition-all">
                  {item.title}
                </h3>
                <p className="text-gray-400 mt-1 group-hover:text-gray-300">
                  {item.institute}
                </p>
                <p className="text-transparent bg-linear-to-r from-orange-400 to-cyan-400 bg-clip-text mt-2 font-bold">
                  {item.score}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Bottom Fade (like hero) */}
      <div className="absolute bottom-0 left-0 w-full h-40 bg-linear-to-t from-black to-transparent" />
    </section>
  );
}
